import styled from 'styled-components';

export const Description = styled.p`
  text-align: left !important; 
  margin-bottom: 40px;
`;

export const TextCounter = styled.p`
  color: #F07E31 !important;
  font-size: 11px !important;
  text-align: left !important; 
`;

export const List = styled.div`
  height: 390px;
  margin: 0 0 -40px 0;
  overflow-y: scroll;
  scrollbar-width: none;

  & > :last-child{
    margin-bottom: 100px;
  }
`;

export const NoContent = styled.div`
  height: 350px;
  color: #D83430;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Footer = styled.div`
  width: 100%; 
  height: 90px;
  padding: 10px 40px;
  left: 0; 
  bottom: 0; 
  position: absolute;   
  display: flex; 
  flex-direction: column;
  justify-content: start; 
  align-items: left;
  box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);
  background: #F8F8F8;
`;
